import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Curtain } from "./components/Curtain";
import { useSmoothScroll, scrollTop } from "./lib/smooth";
import Home from "./pages/Home";
import Studio from "./pages/Studio";
import Servizi from "./pages/Servizi";
import Progetti from "./pages/Progetti";
import Progetto from "./pages/Progetto";
import Contatti from "./pages/Contatti";
import Legal from "./pages/LegalPage";
import NotFound from "./pages/NotFound";

const Shell = () => {
  const { pathname } = useLocation();
  useSmoothScroll();
  useEffect(() => { scrollTop(); }, [pathname]);
  return (
    <div className="grain min-h-screen overflow-x-clip">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[90] focus:bg-ink focus:px-4 focus:py-2 focus:text-paper">Vai al contenuto</a>
      <Curtain />
      <Header />
      <main id="main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/studio" element={<Studio />} />
          <Route path="/servizi" element={<Servizi />} />
          <Route path="/progetti" element={<Progetti />} />
          <Route path="/progetti/:slug" element={<Progetto />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/privacy" element={<Legal kind="privacy" />} />
          <Route path="/cookie" element={<Legal kind="cookie" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="bottom-center" />
    </div>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
